import { Map as ImmutableMap, List as ImmutableList, fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
export const defaultApiWrapper = apiClient => ({
  fetchRenderedContent({
    id,
    contactEmail,
    contactVid,
    objectType,
    subjectId,
    supplementalObjects
  }) {
    const subjectAsSupplementalObject = objectType && subjectId && subjectId !== 'null' && subjectId !== 'undefined' ? {
      [objectType]: subjectId
    } : {};
    return apiClient.post('snippets/v1/render', {
      data: {
        snippetId: id,
        toEmail: contactEmail,
        contactId: contactVid,
        supplementalObjects: Object.assign({}, supplementalObjects, subjectAsSupplementalObject)
      }
    }).catch(error => {
      var _error$responseJSON;
      if (((_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.category) === 'UNAUTHORIZED') {
        FloatingAlertStore.addAlert({
          id: 'snippet-error',
          titleText: I18n.text('draftPlugins.snippetsPlugin.permissionsError.title'),
          message: I18n.text('draftPlugins.snippetsPlugin.permissionsError.message'),
          type: 'danger'
        });
      }
      Raven.captureException(error);
    });
  },
  // @ts-expect-error ts-migrate FIXME
  fetchUnrenderedContent({
    id
  }) {
    return apiClient.get(`snippets/v1/snippets/${id}`);
  },
  // @ts-expect-error ts-migrate FIXME
  searchSnippets({
    count,
    offset,
    query
  }) {
    return apiClient.post('salescontentsearch/v2/search', {
      data: {
        contentTypesToHydrate: ['SNIPPET'],
        filters: [{
          field: 'content_type',
          values: ['SNIPPET']
        }],
        limit: count,
        offset,
        query
      }
    }).then(response => fromJS(response)).catch(error => {
      Raven.captureException(error);
    });
  }
});
export const fetchAllSnippets = () => http.get('snippets/v1/snippets').then(response => ImmutableMap({
  hasMore: false,
  offset: 0,
  count: response.length,
  total: response.length,
  results: ImmutableList(response).map(snippet => fromJS(snippet))
}));
export const searchSnippets = ({
  count,
  offset,
  query
}) => http.post('salescontentsearch/v2/search', {
  data: {
    contentTypesToHydrate: ['SNIPPET'],
    filters: [{
      field: 'content_type',
      values: ['SNIPPET']
    }],
    limit: count,
    offset,
    query
  }
}).then(response => fromJS(response));